import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Button,
  Card,
  CardContent,
  Grid2,
  IconButton,
  Typography,
  Box,
  Avatar,
  TablePagination,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import moment from "moment";
import MaterialButton from "../../../components/MaterialButton";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { Doughnut } from "react-chartjs-2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ChevronLeft, ChevronRight, VisibilityOutlined } from "@mui/icons-material";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import MiniCard from "../MiniCard";
import { useDispatch, useSelector } from "react-redux";
import {
  checkIn,
  checkOut,
  setcheckInTime,
  setcheckOutTime
} from "../../../Redux/reducers/timerSlice";

ChartJS.register(ArcElement, Tooltip, Legend);
const HRdashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isCheckedIn, checkInTime, checkOutTime } =
    useSelector((state) => state.timer);
  const datas = sessionStorage.getItem("user");

  const parsedData = JSON.parse(datas); // Convert the string to an object

  const [displayTime, setDisplayTime] = useState("00:00:00");
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);
  const baseSecondsRef = useRef(0);
  const [ischeckIn,setisCheckIn] = useState(false)
  

  const [birthpopup, setBirthdayPopup] = useState(false);
  const [employeeLeave, setEmployeeLeave] = useState([]);
  const [dor, setDor] = useState([]);
  const [employeCount, setEmployeCount] = useState("");
  const [birthday, setbirthday] = useState([]);
  const [dates, setData] = useState({});
  const [count, setCount] = useState([]);
  const [leaveCount, setLeaveCount] = useState([]);  
  const [depart, setdepart] = useState({
    value: [],
    label: [],
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [attendanceData, setAttendanceData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    getleave();
    fetchEmployeeDor();
    handeldatas();
    leavecount();
    fetchAttendanceData();
    handleCheck();

    // fetchAllEmployeeLeaveDetails();
  }, []);

  //checkin checkout logic useffect
  useEffect(() => {
    handleCheck(); // on mount

    return () => stopTimer(); // cleanup
  }, []);

  useEffect(() => {
    handleCheck(); // initial load
    const syncInterval = setInterval(handleCheck, 5 * 60 * 1000); // 5 min
    return () => clearInterval(syncInterval);
  }, []);

  useEffect(() => {
    window.addEventListener("online", handleCheck);
    return () => {
      window.removeEventListener("online", handleCheck);
    };
  }, []);

  //checkin checkout logic end useffect

  const handleCheckOut = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to clock out?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        // onEmployeeeSubmit();
        handleCheckIn();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const [totalLeaveCount, settotalLeaveCount] = useState(0);

  const getleave = async () => {
    let query = `query leavedetailbyme($id:String!){
      leaveDetailsByMe(id: $id){
        user{
          email
        }
        status
        takedLeave
        leaveType {
          id
          name
        }
        leaveCount
        workFromHome
      }
    }`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      let result = response.data.data.leaveDetailsByMe;

      let filterdata = result.filter(
        (item) =>
          item?.leaveType?.name !== "loss_of_pay" &&
          item?.leaveType?.name !== "paternity_leave" &&
          item?.leaveType?.name !== "maternity_leave" &&
          item?.leaveType?.name !== "work_from_home"
      );

      let totalLeaveCounts = filterdata.reduce((acc, val) => {
        return acc + (val.leaveCount || 0); // Assuming 'leaveCount' is a property in the data
      }, 0);

      let totaltakedLeaveCounts = filterdata.reduce((acc, val) => {
        return acc + (val.takedLeave || 0); // Assuming 'leaveCount' is a property in the data
      }, 0);

      let finalresult = totalLeaveCounts - totaltakedLeaveCounts;

      settotalLeaveCount(finalresult);
    } catch (error) {
      console.error("errorssss:", error.message);
    }
  };

  //checkin checkout logic and functions
  const handleCheckIn = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);

    const queryCheckIn = `mutation CheckIn($id: String!) {
  checkInUpdate(id: $id) {
    success
    message
    error
    set
    checkin {
      id
      user {
        id
        firstName
        lastName
      }
      checkIn
      checkOut
      totalWorkingHours
      overtime
    }
  }
}`;
    const queryCheckOut = `mutation CheckOut($id: String!) {
  checkOutTime(id: $id) {
    success
    message
    error
    set
    checkout {
      id
      user {
        id
        firstName
        lastName
      }
      checkIn
      checkOut
      totalWorkingHours
      overtime
    }
  }
}`;

    if (ischeckIn) {
      // Clock-Out logic
      try {
        const response = await axios.post(BASEURL, {
          query: queryCheckOut,
          variables: { id: parsedData?.id }, // Ensure `id` is valid and exists
        });

        console.log("Check-Out Response:", response.data);

        if (response.data.errors) {
          Swal.fire({
            title: response.data.errors[0].message,
            showConfirmButton: true,
            timer: 2500,
          });
          console.error("Check-Out Error:", response.data.errors[0].message);
          return; // Exit if there's a server-side error
        }
        // setIsCheckedIn(false);
        setisCheckIn(false)
        dispatch(checkOut());
        dispatch(setcheckOutTime(data?.checkOut));
      } catch (error) {
        console.error("Error during Check-Out:", error.message);
      }
    } else {
      // Clock-In logic
      try {
        const response = await axios.post(BASEURL, {
          query: queryCheckIn,
          variables: { id: parsedData?.id },
        });

        const graphqlError = response?.data?.errors?.[0]?.message;
        const checkInData = response?.data?.data?.checkInUpdate;

        if (graphqlError || checkInData?.error || checkInData?.success === false) {
          const errorMessage =
            graphqlError ||
            checkInData?.message ||
            "Check-in could not be completed.";

          Swal.fire({
            icon: "warning",
            title: "Check-In Unavailable",
            text: errorMessage,
            confirmButtonText: "Okay",
            confirmButtonColor: "#2563EB",
            showCloseButton: true,
            allowOutsideClick: false,
            customClass: {
              popup: "checkin-alert-popup",
              title: "checkin-alert-title",
              confirmButton: "checkin-alert-button",
            },
          });

          console.error("Check-In Error:", errorMessage);
          return;
        }

        dispatch(checkIn());

        dispatch(
          setcheckInTime(
            checkInData?.checkin?.checkIn
          )
        );

        handleCheck(true);

      } catch (error) {
        console.error("Error during Check-In:", error.message);

        Swal.fire({
          icon: "error",
          title: "Something Went Wrong",
          text: "Unable to complete check-in. Please try again.",
          confirmButtonText: "Okay",
          confirmButtonColor: "#2563EB",
          showCloseButton: true,
        });
      }
    }
  };

  const handleCheck = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);

    const queryCheckIn = `
    query GetLatestBiometricAttendance($userId: ID!) {
      latestBiometricAttendanceByUser(userId: $userId) {
        id
        checkIn
        checkOut
        totalWorkingHours
        overtime
        resumeTime
      }
    }
  `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: queryCheckIn,
          variables: { userId: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data?.latestBiometricAttendanceByUser;

      if (data && data.checkOut === null) {
        const resumeSeconds = parseTimeToSeconds(data.resumeTime || "00:00:00");

        // Save base resume seconds and start time (in ms)
        baseSecondsRef.current = resumeSeconds;
        startTimeRef.current = Date.now();
setisCheckIn(true)
        startAccurateTimer();
      } else {
        stopTimer();
        setDisplayTime("00:00:00");
        setisCheckIn(false)
      }
    } catch (error) {
      console.error("Error during Check-In:", error.message);
    }
  };

  const parseTimeToSeconds = (timeStr) => {
    const [h, m, s] = timeStr.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  // Format seconds → "HH:MM:SS"
  const formatTime = (seconds) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const startAccurateTimer = () => {
    stopTimer();
    intervalRef.current = setInterval(() => {
      const now = Date.now();
      const elapsed = Math.floor((now - startTimeRef.current) / 1000);
      const total = baseSecondsRef.current + elapsed;
      setDisplayTime(formatTime(total));
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(intervalRef.current);
  };
  //checkin checkout logic end

  const fetchEmployeeDor = async () => {
    const query = `
        query GetEmployeeLeaveDashboard { 
            employeeLeaveDashboard { 
                employeeName 
                leaveStartDate 
                leaveEndDate 
                primaryDelegate 
                secondaryDelegate 
                delegateEmployeeName 
                assignedTasks 
            } 
        }`;

    try {
      const response = await axios.post(
        BASEURL,
        { query },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = response.data.data?.employeeLeaveDashboard || [];

      const mappedData = data.map((item) => ({
        employeeName: item.employeeName || "N/A",
        primaryDelegate: item.primaryDelegate || "Not Assigned",
        secondaryDelegate: item.secondaryDelegate || "Not Assigned",
        assignedTasks:
          item.assignedTasks?.length > 0
            ? item.assignedTasks
            : "No Tasks Assigned",
      }));

      setDor(mappedData);
    } catch (error) {
      console.error("Unable to fetch Data", error);
    }
  };

  const dashboardData = `
query HRDashboard($userId: ID!) {
  totalLeaveConfigurations
  approvedLeavesWithoutLop(userId: $userId)
  approvedLeavesWithLop(userId: $userId)
  pendingLeavesCount(userId: $userId)
  attendanceDetails {
    checkIn
    checkOut
    firstName
    department
  }
  attendanceCount
  birthdayUsers {
    firstName
    department
  }
  pendingRequestsCount {
    pendingLeaveCount
    pendingWfhCount
    pendingRegularizationCount
  }
  employeeTypeCount {
    typeName
    count
  }
  departmentCount {
    departmentName
    count
  }
}
`;

  const handeldatas = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: dashboardData,
          variables: {
            userId: parsedData?.id,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data?.data;
      setData(data);
      const temps = [];

      data?.attendanceDetails.map((item) => {
        if (item?.firstName !== "") {
          temps.push(item);
        }
      });

      setEmployeeLeave(temps);
      setEmployeCount(data?.attendanceCount);
      setbirthday(data?.birthdayUsers);
      const temp = [];
      data?.employeeTypeCount.map((item, ind) => {
        temp.push({
          id: ind + 1,
          value: item?.count,
          label: item?.typeName,
        });
      });
      const lable = [];
      const value = [];
      data?.departmentCount?.map((item) => lable?.push(item?.departmentName));
      data?.departmentCount?.map((item) => value?.push(item?.count));
      setdepart({
        value: value,
        label: lable,
      });
      setCount(temp);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const filteredLabels = [];
  const filteredData = [];
  const backgroundColors = [];
  const hoverBackgroundColors = [];

  leaveCount?.map((item, index) => {
    if (
      item?.leaveType !== "loss_of_pay" &&
      item?.leaveType !== "paternity_leave" &&
      item?.leaveType !== "maternity_leave" &&
      item?.leaveType !== "work_from_home"
    ) {
      filteredLabels.push(
        item?.leaveType == "restricted_holiday"
          ? "Restricted Holiday"
          : item?.leaveType == "casual_leave"
          ? "Casual Leave"
          : item?.leaveType == "earned_leave"
          ? "Earned Leave"
          : item?.leaveType == "sick_leave"
          ? "Sick Leave"
          : item?.leaveType
      );
      filteredData.push(item?.remaining);
      backgroundColors.push(
        ["#FF6384", "#36A2EB", "#FFCE56", "#36ba45"][index % 4]
      );
      hoverBackgroundColors.push(
        ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"][index % 4]
      );
    }
  });
  const pieData = {
    labels: filteredLabels,
    datasets: [
      {
        label: "Leave Details",
        data: filteredData,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: hoverBackgroundColors,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const rows = [
    { id: 1, lastName: "Snow", firstName: "Jon", age: 35 },
    { id: 2, lastName: "Lannister", firstName: "Cersei", age: 42 },
    { id: 3, lastName: "Lannister", firstName: "Jaime", age: 45 },
    { id: 4, lastName: "Stark", firstName: "Arya", age: 16 },
    { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: null },
    { id: 6, lastName: "Melisandre", firstName: null, age: 150 },
    { id: 7, lastName: "Clifford", firstName: "Ferrara", age: 44 },
    { id: 8, lastName: "Frances", firstName: "Rossini", age: 36 },
    { id: 9, lastName: "Roxie", firstName: "Harvey", age: 65 },
    { id: 41, lastName: "Stark", firstName: "Arya", age: 16 },
    { id: 51, lastName: "Targaryen", firstName: "Daenerys", age: null },
    { id: 61, lastName: "Melisandre", firstName: null, age: 150 },
    { id: 17, lastName: "Clifford", firstName: "Ferrara", age: 44 },
    { id: 18, lastName: "Frances", firstName: "Rossini", age: 36 },
    { id: 19, lastName: "Roxie", firstName: "Harvey", age: 65 },
  ];

  const newBoxShadow = "0 6px 20px rgba(182, 186, 203, 0.3)";

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
  );

  const leaveCountByUser = `
  query leavedetailbyme($id:String!){
  leaveDetailsByMe(id: $id){
    user{
      email
    }
    status
    takedLeave
    leaveType {
      id
      name
    }
    leaveCount
    workFromHome
  }
}
  `;
  const leavecount = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    const encodedId = btoa(parsedData?.id);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: leaveCountByUser,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data.leaveDetailsByMe;

      let filterdata = data.filter(
        (val) => val.leaveType.name !== "loss_of_pay"
      );

      const remainingLeaves = filterdata.map((item) => ({
        leaveType: item.leaveType.name,
        remaining: item.leaveCount - item.takedLeave,
      }));
      setLeaveCount(remainingLeaves);

      // setbirthday(data?.birthdayUsers);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };
  const getLatestAttendanceData = (data) => {
    const latestData = {};
    data?.forEach((item) => {
      const date = new Date(item.checkIn || item.checkOut)
        .toISOString()
        .slice(0, 10);
      if (
        !latestData[date] ||
        new Date(item.lastUpdate) > new Date(latestData[date].lastUpdate)
      ) {
        latestData[date] = item;
      }
    });
    return Object.values(latestData);
  };
  const filteredAttendanceData = getLatestAttendanceData(attendanceData).filter(
    (item) => {
      const date = new Date(item.checkIn);
      return (
        date.getFullYear() === parseInt(selectedYear) &&
        date.getMonth() + 1 === parseInt(selectedMonth) &&
        item.checkIn &&
        !item.checkOut // Only include entries with checkIn but no checkOut
      );
    }
  );
  const attendanceQuery = `
  query userAttendanceDetails($id: String!) {
    userAttendanceDetails(id: $id) {
      data{
      id
      checkIn
      checkOut
      totalWorkingHours
      }
    	error
      message
    }
  }
`;

  const fetchAttendanceData = async () => {
    const data = sessionStorage.getItem("user");
    const parsedData = JSON.parse(data);
    const encodedId = btoa(parsedData?.id);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: attendanceQuery,
          variables: { id: parsedData?.id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setAttendanceData(response.data?.data?.userAttendanceDetails?.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  return (
    <DashboardLayout isCheckedIn={isCheckedIn}>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {birthpopup && (
        <Dialog
          maxWidth="sm"
          fullWidth
          // {...rest}
          open={true}
        >
          <DialogTitle>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                color: "#6a1b9a",
                fontSize: "1.2rem",
              }}
            >
              Birthday Celebrations For Today🎉
            </Typography>
          </DialogTitle>

          <DialogContent variant="body2">
            {birthday.map((person, index) => (
              <Box
                key={index}
                sx={{
                  marginBottom: 1,
                  padding: 1,
                  borderRadius: 1,
                  backgroundColor: index % 2 === 0 ? "#f3e5f5" : "#ede7f6",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    color: "#6a1b9a",
                    fontSize: "0.95rem",
                  }}
                >
                  {person.firstName}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "0.85rem" }}
                >
                  {person.department}
                </Typography>
              </Box>
            ))}
          </DialogContent>

          <DialogActions>
            <MaterialButton
              color="error"
              variant="text"
              onClick={() => setBirthdayPopup(false)}
            >
              Cancel
            </MaterialButton>
          </DialogActions>
        </Dialog>
      )}
      <Box sx={{ padding: 1, zIndex: 1 }}>
        <Grid2 container spacing={2}>
          {/* Mark Attendance Card */}

          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 2,
                padding: 0.5,
                height: 250,
              }}
            >
              <CardContent>
                {/* Title */}
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold", marginBottom: 2 }}
                >
                  Mark Attendance
                </Typography>

                {/* Timer Section */}
                <Box
                  sx={{
                    backgroundColor: "#fff5ec",
                    borderRadius: 2,
                    padding: 1.6,
                    borderLeft: `4px solid ${ischeckIn ? "#fc133d" : "#ffa726"}`,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 2,
                    boxShadow: `2px 2px 2px ${ischeckIn? "#dbadb6" : "#e7c391"}`,
                  }}
                >
                  <Box>
                    <Typography sx={{ color: "#4d5154", fontSize: "15px" }}>
                      Working Hours
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#373b3e",
                        fontSize: "20px",
                      }}
                    >
                      {ischeckIn ? displayTime : "00:00:00"}
                    </Typography>
                  </Box>
                  <Button
                    variant="gradient"
                    sx={{
                      backgroundColor: ischeckIn ? "#fc133d" : "#ffa726",
                      color: "#fff",
                      fontWeight: "bold",
                      marginTop: "20px",
                      marginLeft: "5px",
                    }}
                    onClick={ischeckIn ? handleCheckOut : handleCheckIn}
                  >
                    {ischeckIn ? "Clock-Out" : "Clock-In"}
                  </Button>
                </Box>
                {ischeckIn ? (
                  <Typography
                    sx={{
                      color: "#4d5154",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  >
                    Checked-in...
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#4d5154",
                      fontSize: "15px",
                      marginTop: "10px",
                    }}
                  >
                    Last Clock Out: {checkOutTime !== "00:00:00" ? moment(checkOutTime).format("hh:mm A") : "00:00:00"}
                  </Typography>
                )}

                <Box sx={{ borderBottom: "1px solid #d3d3d4" }}></Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#373b3e",
                    cursor: "pointer",
                    fontWeight: "500",
                    marginTop: "5%",
                    "&:hover": {
                      color: "#3F51B5d4",
                    },
                  }}
                  onClick={() => navigate("/calendar")}
                >
                  View Attendance
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          {/* Attendance & Leaves */}
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 3.5 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                boxShadow: newBoxShadow,
                py: 0.4,
                px: 0.1,
                minHeight: 250,
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ fontWeight: "bold" }}
                >
                  Attendance & Leaves
                </Typography>
                <Grid container spacing={1.8}>
                  {[
                    {
                      title: 'Total Leaves',
                      value: totalLeaveCount,
                      color: '#ff902f',
                    },
                    {
                      title: 'Leaves Taken',
                      value: dates?.approvedLeavesWithoutLop,
                      color: '#fc6075',
                    },
                    {
                      title: 'Pending Approval',
                      value: dates?.pendingLeavesCount,
                      color: '#9368e9',
                    },
                    {
                      title: 'Loss of Pay',
                      value: dates?.approvedLeavesWithLop,
                      color: '#fc133d',
                    },
                  ].map((stat, index) => (
                    <Grid item xs={6} sm={6} key={index}>
                      <Card
                        elevation={0}
                        sx={{
                          border: '1px solid #e8eaf0',
                          borderRadius: 2,
                          backgroundColor: `${stat.color}0A`,
                          borderLeft: `3px solid ${stat.color}`,
                          boxShadow: `0 3px 8px ${stat.color}20`,
                          transition: 'box-shadow 0.2s ease',
                          '&:hover': {
                            boxShadow: `0 6px 8px ${stat.color}20`,
                          },
                        }}
                      >
                        <CardContent
                          sx={{
                            p: 0.2,
                            '&:last-child': { pb: 0.4 },
                          }}
                        >
                          <Typography
                            variant="h5"
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              color: stat.color,                              
                            }}
                          >
                            {stat.value}
                          </Typography>

                          <Typography
                            variant="body2"
                            align="center"
                            sx={{
                              fontSize: '14px',
                              color: '#4d5154',
                              fontWeight: 500,
                            }}
                          >
                            {stat.title}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>

                <Box
                  sx={{
                    borderBottom: "1px solid #d3d3d4",
                    my: 1,
                    marginTop: "20px",
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#373b3e",
                    cursor: "pointer",
                    fontWeight: "500",
                    marginTop: "6%",
                    "&:hover": {
                      color: "#3F51B5d4",
                    },
                  }}
                  onClick={() =>
                    navigate("/apply-leave/apply-leaverequest")
                  }
                >
                  Apply Leaves
                </Typography>
              </CardContent>
            </Card>
          </Grid2>
          {/* Employees Present */}
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 2.5 }}>
              <Card
                elevation={5}
                sx={{
                  borderRadius: 2,
                  padding: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#ffffff", // Plain white background
                  boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
                  height: 250,
                }}
              >
                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#495057",
                    marginBottom: 2,
                    textAlign: "center",
                  }}
                >
                  Employees Present
                </Typography>

                {/* Count */}
                <Box
                  sx={{
                    backgroundColor: "#f8f9fa",
                    padding: 0,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100px",
                    height: "100px",
                    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "40px",
                      fontWeight: "bold",
                      color: "#28a745",
                    }}
                  >
                    {employeCount}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    fontSize: "0.85rem",
                    // fontStyle: "italic",
                    opacity: 0.8,
                    textAlign: "center",
                    // padding:0.5
                    marginTop: 1,
                  }}
                >
                  Attendance count for today
                </Typography>
              </Card>                                 
          </Grid2>

          {/* Employee's Attendance */}
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{ borderRadius: 2, backgroundColor: "#fff", minHeight: 485, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: 0,
                  padding: 1.8,
                  fontSize: "1rem",
                }}
              >
                Employee's Attendance
              </Typography>
              <Box
                sx={{                  
                  borderRadius: '2px',
                  overflow: 'hidden',
                  backgroundColor: '#fff',
                }}
              >
                <TableContainer
                  sx={{
                    height: 370,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >                  
                  <Table size="small" sx={{ margin: 0 }}>
                    <TableHead>
                      <TableRow
                        sx={{
                          backgroundColor: '#EDF5FF',
                          '& th': {
                            py: 1,
                            px: 1.5,
                            fontWeight: 700,
                            color: '#000',
                            fontSize: '0.8rem',
                            whiteSpace: 'nowrap',
                            borderBottom: '1px solid rgb(1, 43, 170)',
                          },
                        }}
                      >
                        <TableCell sx={{ width: '40%' }}>Name</TableCell>
                        <TableCell sx={{ width: '26%' }}>Department</TableCell>
                        <TableCell sx={{ width: '18%' }}>Check In</TableCell>
                        <TableCell sx={{ width: '18%' }}>Check Out</TableCell>
                      </TableRow>
                    <TableBody>
                      {employeeLeave
                        ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                          <TableRow
                            key={row.id ?? index}
                            sx={{
                              '& td': {
                                py: 0.8,
                                px: 1.5,
                                fontSize: '0.75rem',
                                color: '#475467',
                                borderBottom: '1px solid #f0f1f5',
                              },
                              '&:last-child td': { borderBottom: 0 },
                              '&:hover': { backgroundColor: '#f8faff' },
                            }}
                          >
                            <TableCell sx={{ fontWeight: 600, color: '#26324d !important' }}>
                              {row.firstName || '-'}
                            </TableCell>

                            <TableCell>{row.department || '-'}</TableCell>

                            <TableCell>
                              {row?.checkIn ? moment(row.checkIn).format('hh:mm A') : '-'}
                            </TableCell>

                            <TableCell>
                              {row?.checkOut ? (
                                moment(row.checkOut).format('hh:mm A')
                              ) : (
                                <Box
                                  component="span"
                                  sx={{
                                    display: 'inline-block',
                                    px: 0.8,
                                    py: 0.25,
                                    borderRadius: 1,
                                    backgroundColor: '#fff4e5',
                                    color: '#b76e00',
                                    fontSize: '0.68rem',
                                    fontWeight: 600,
                                  }}
                                >
                                  Pending
                                </Box>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}

                      {(!employeeLeave || employeeLeave.length === 0) && (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            align="center"
                            sx={{ py: 3, color: '#98a2b3', fontSize: '0.75rem' }}
                          >
                            No attendance records available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                    </TableHead>

                  </Table>
                </TableContainer>

                {/* Pagination stays at the bottom of the fixed table area */}
                <Box
                  sx={{
                    height: 42,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    borderTop: '1px solid #e0e3e8',
                    backgroundColor: '#fff',
                    '& .MuiTablePagination-root': {
                      height: 42,
                      overflow: 'hidden',
                    },
                    '& .MuiTablePagination-toolbar': {
                      minHeight: '42px !important',
                      height: 42,
                      pl: 1,
                      pr: 0.5,
                    },
                  }}
                >
                  {/* Keep your existing TablePagination here */}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        px: 1,
                        backgroundColor: '#fff',
                        border: '1px solid #e8eaf0',
                        borderTop: 0,
                        borderRadius: '0 0 8px 8px',
                        '& .MuiTablePagination-root': {
                          minHeight: 40,
                          overflow: 'hidden',
                        },
                        '& .MuiTablePagination-toolbar': {
                          minHeight: 40,
                          pl: 1,
                          pr: 0.5,
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                          fontSize: '0.9rem',
                          color: '#667085',
                          m: 0,
                        },
                      }}
                    >
                      <TablePagination
                        rowsPerPageOptions={[10]}
                        component="div"
                        count={employeeLeave?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={({ count, page, rowsPerPage, onPageChange }) => (
                          <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                            <IconButton
                              size="small"
                              onClick={event => onPageChange(event, page - 1)}
                              disabled={page === 0}
                              sx={{ p: 0.5 }}
                            >
                              <ChevronLeft fontSize="small" />
                            </IconButton>

                            <IconButton
                              size="small"
                              onClick={event => onPageChange(event, page + 1)}
                              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                              sx={{ p: 0.5 }}
                            >
                              <ChevronRight fontSize="small" />
                            </IconButton>
                          </Box>
                        )}
                      />
                    </Box>
                </Box>
              </Box>                         
            </Card>
          </Grid2>
       
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Grid2 container spacing={1}>
              <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Grid2 container spacing={2}>
                  {/* Pending Approvals */}
                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 7 }}>
                    <Card
                      elevation={2}
                      sx={{
                        borderRadius: 2,                
                        backgroundColor: "#fff",
                        boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)"                
                      }}
                    >
                      <CardContent>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 'bold',
                            mb: 0.4,                    
                          }}
                        >
                          Pending Approvals
                        </Typography>

                        {[
                          {
                            title: 'Leaves',
                            count: dates?.pendingRequestsCount?.pendingLeaveCount,
                            color: '#3987D5',
                            bgColor: '#EDF5FF',
                            navigates: '/apply-leave',
                          },
                          {
                            title: 'WFH',
                            count: dates?.pendingRequestsCount?.pendingWfhCount,
                            color: '#20A58A',
                            bgColor: '#E9F8F3',
                            navigates: '/wfh-management',
                          },
                          {
                            title: 'Regularization',
                            count: dates?.pendingRequestsCount?.pendingRegularizationCount,
                            color: '#D99A20',
                            bgColor: '#FFF6E5',
                            navigates: '/regularization-request',
                          },
                        ].map((item, index) => (
                          <Box
                            key={index}
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              mb: 0.5,
                              px: 1.25,
                              py: 0.15,
                              backgroundColor: item.bgColor,
                              border: `1px solid ${item.color}25`,
                              borderRadius: '4px',
                              transition: 'background-color 0.2s ease',
                              '&:hover': {
                                backgroundColor: `${item.color}18`,
                              },
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{
                                  fontSize: '0.75rem',
                                  fontWeight: 600,
                                  color: '#4d5154',
                                }}
                              >
                                {item.title}
                              </Typography>

                              <Typography
                                sx={{
                                  fontSize: '0.9rem',
                                  fontWeight: 700,
                                  color: item.color,
                                  lineHeight: 1.4,
                                }}
                              >
                                {item.count ?? 0}
                              </Typography>
                            </Box>

                            <IconButton
                              size="small"
                              onClick={() => navigate(item.navigates)}
                              aria-label={`View ${item.title} approvals`}
                              sx={{
                                color: item.color,
                                backgroundColor: '#ffffff',
                                border: `1px solid ${item.color}45`,
                                borderRadius: '4px',
                                p: 0.6,
                                '&:hover': {
                                  backgroundColor: item.color,
                                  color: '#ffffff',
                                },
                              }}
                            >
                              <VisibilityOutlined fontSize="small" />
                            </IconButton>
                          </Box>
                        ))}
                      </CardContent>
                    </Card>
                  </Grid2>

                  {/* Today’s Birthdays */}
                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
                    <Card
                      sx={{
                        borderRadius: 2,
                        boxShadow: "0 3px 8px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#f9f6fd",
                        padding: 0.4,
                        height: 200,                                    
                      }}
                    >
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 1
                          }}
                        >
                          <Avatar
                            sx={{
                              width: 32,
                              height: 32,
                              marginRight: 0.5,
                              backgroundColor: "#8e44ad",
                              color: "#fff",
                              fontSize: "1rem", // Smaller font size for the emoji
                            }}
                          >
                            🎂
                          </Avatar>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: "600",
                              color: "#4a148c",                    
                            }}
                          >
                            Today’s Birthdays
                          </Typography>
                        </Box>
                        {/* {birthday.map((person, index) => ( */}
                        {birthday?.length == 1 ? (
                          <Box                  
                            sx={{
                              marginBottom: 1,
                              padding: 1,
                              borderRadius: 1,
                              minHeight: 80,
                              backgroundColor: "#ede7f6",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                color: "#6a1b9a",                      
                              }}
                            >
                              {birthday?.[0]?.firstName}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"                    
                            >
                              {birthday?.[0]?.department}
                            </Typography>
                          </Box>
                        ) : birthday?.length > 1 ? (
                          <>
                            <Box                    
                              sx={{
                                marginBottom: 1,
                                py: 0.1,
                                px: 0.8,
                                borderRadius: 1,
                                backgroundColor: "#fff",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: "bold",
                                  color: "#6a1b9a",                        
                                }}
                              >
                                {birthday?.[0]?.firstName}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"                      
                              >
                                {birthday?.[0]?.department}
                              </Typography>
                            </Box>
                            <Box                              
                              sx={{
                                marginBottom: 1,
                                py: 0.1,
                                px: 0.8,
                                borderRadius: 1,
                                backgroundColor: "#f3e5f5",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: "bold",
                                  color: "#6a1b9a",                        
                                }}
                              >
                                {birthday?.[1]?.firstName}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"                      
                              >
                                {birthday?.[1]?.department}
                              </Typography>
                            </Box>
                          </>
                        ) : (
                          <Box
                            // key={}
                            sx={{
                              marginTop: 2,
                              padding: 5,
                              borderRadius: 1,
                              backgroundColor: "#f3e5f5",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                color: "#6a1b9a",                      
                              }}
                            >
                              No Birthday
                            </Typography>
                          </Box>
                        )}
                        {birthday?.length > 2 && (
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#373b3e",
                              cursor: "pointer",
                              fontWeight: "500",
                              marginTop: "3%",
                              "&:hover": {
                                color: "#3F51B5d4",
                              },
                            }}
                            onClick={() => {
                              setBirthdayPopup(true);
                            }}
                          >
                            See Birthdays
                          </Typography>
                        )}
                      </CardContent>
                    </Card>
                  </Grid2>
                </Grid2>
              </Grid2>
              {/* Available Leave & WFH */}
              <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Card
                  elevation={3}x
                  sx={{
                    borderRadius: 2,                  
                    boxShadow: newBoxShadow,
                    padding: 1,
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: "bold" }}
                    >
                      Available Leave & WFH
                    </Typography>
                    <div style={{ marginTop: "3%" }}>
                      <Doughnut
                        height={"192px"}
                        data={pieData}
                        options={pieOptions}
                      />
                    </div>
                  </CardContent>
                </Card>
              </Grid2>
            </Grid2>
          </Grid2>          
          
          {/* Leaves and Respective DORs */}
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 2,
                boxShadow: newBoxShadow,
                padding: 1,
              }}
            >              
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: 0,
                  padding: 1,
                  fontSize: "1rem",
                }}
              >
                Leaves and Respective DORs
              </Typography>              
              <Box
                sx={{
                  border: '1px solid #e0e3e8',
                  borderRadius: '2px',
                  overflow: 'hidden',
                  backgroundColor: '#fff',
                }}
              >
                <TableContainer
                  sx={{
                    height: 340,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  <Table
                    size="small"
                    sx={{
                      margin: 0,
                      tableLayout: 'fixed',
                      width: '100%',
                    }}
                  >
                    <TableHead
                      sx={{
                        '& th': {
                          py: 1,
                          px: 1.5,
                          fontWeight: 700,
                          color: '#28a745',
                          fontSize: '0.8rem',
                          whiteSpace: 'nowrap',
                          backgroundColor: '#def6e3',
                          borderBottom: '1px solid #28a745',
                        },
                      }}
                    >
                      <TableRow>
                        <TableCell sx={{ width: '28%' }}>Employee</TableCell>
                        <TableCell sx={{ width: '24%' }}>Primary DOR</TableCell>
                        <TableCell sx={{ width: '24%' }}>Secondary DOR</TableCell>
                        <TableCell sx={{ width: '24%' }}>Task</TableCell>
                      </TableRow>
                      <TableBody>
                        {dor
                          ?.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => (
                            <TableRow
                              key={row.id ?? index}
                              sx={{
                                '& td': {
                                  py: 0.8,
                                  px: 1.5,
                                  fontSize: '0.75rem',
                                  color: '#475467',
                                  borderBottom: '1px solid #f0f1f5',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                },
                                '&:last-child td': {
                                  borderBottom: 0,
                                },
                                '&:hover': {
                                  backgroundColor: '#f6fcf7',
                                },
                              }}
                            >
                              <TableCell sx={{ fontWeight: 600, color: '#26324d !important' }}>
                                {row.employeeName || '-'}
                              </TableCell>

                              <TableCell>{row.primaryDelegate || '-'}</TableCell>

                              <TableCell>{row.secondaryDelegate || 'N/A'}</TableCell>

                              <TableCell>{row.assignedTasks || 'N/A'}</TableCell>
                            </TableRow>
                          ))}

                        {(!dor || dor.length === 0) && (
                          <TableRow>
                            <TableCell
                              colSpan={4}
                              align="center"
                              sx={{
                                py: 3,
                                color: '#98a2b3',
                                fontSize: '0.75rem',
                              }}
                            >
                              No Data Available
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </TableHead>

                  </Table>
                </TableContainer>

                {/* Fixed pagination footer */}
                <Box
                  sx={{
                    height: 42,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    borderTop: '1px solid #e0e3e8',
                    backgroundColor: '#fff',
                    '& .MuiTablePagination-root': {
                      height: 42,
                      overflow: 'hidden',
                    },
                    '& .MuiTablePagination-toolbar': {
                      minHeight: '42px !important',
                      height: 42,
                      pl: 1,
                      pr: 0.5,
                    },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                      fontSize: '0.75rem',
                      color: '#667085',
                      m: 0,
                    },
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={dor?.length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={({ count, page, rowsPerPage, onPageChange }) => (
                      <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                        <IconButton
                          size="small"
                          onClick={event => onPageChange(event, page - 1)}
                          disabled={page === 0}
                          sx={{ p: 0.5 }}
                        >
                          <ChevronLeft fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={event => onPageChange(event, page + 1)}
                          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                          sx={{ p: 0.5 }}
                        >
                          <ChevronRight fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  />
                </Box>
              </Box>
            </Card>
          </Grid2>
          {/* Missing Check-Out Days */}
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Card
              elevation={3}
              sx={{
                boxShadow: newBoxShadow,
                borderRadius: 2,
                padding: 2,
                minHeight: 440,
              }}
            >              
              {/* Title and Select Boxes Section */}
              <div
                style={{
                  alignItems: "center",
                  marginBottom: "56px",                    
                }}
              >
                <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                  Missing Check-Out Days
                </Typography>
                <div
                  style={{ display: "flex", gap: "16px", marginTop: "10px" }}
                >
                  <div>
                    <select
                      value={selectedYear}
                      onChange={handleYearChange}
                      style={{
                        width: "190px",
                        border: "1px solid gray",
                        textAlign: "center",
                        padding: "10px",
                        borderRadius: "5px",
                        color: "#3F51B5d4",
                        paddingRight: "3px",
                        outline: "none",
                        overflow: "scroll",
                      }}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const year = new Date().getFullYear() - i;
                        return (
                          <option
                            key={year}
                            value={year}
                            style={{ overflow: "scroll" }}
                          >
                            {year}
                          </option>
                        );
                      })}
                    </select>
                    <select
                      style={{
                        width: "190px",
                        border: "1px solid gray",
                        textAlign: "center",
                        padding: "10px",
                        borderRadius: "5px",
                        color: "#3F51B5d4",
                        marginLeft: "6px",
                        outline: "none",
                      }}
                      value={selectedMonth}
                      onChange={handleMonthChange}
                      // className="border rounded p-2"
                    >
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {new Date(0, i).toLocaleString("default", {
                            month: "long",
                          })}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {filteredAttendanceData.length > 0 ? (
                  <div>
                    {filteredAttendanceData.map((entry, index) => (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <MiniCard>
                          Date: {new Date(entry.checkIn).toLocaleDateString()}
                        </MiniCard>

                        <MiniCard>
                          Check In:{" "}
                          {entry.checkIn
                            ? new Date(entry.checkIn).toLocaleTimeString()
                            : "N/A"}
                        </MiniCard>
                        <MiniCard>
                          Check Out:{" "}
                          {entry.checkOut
                            ? new Date(entry.checkOut).toLocaleTimeString()
                            : "N/A"}
                        </MiniCard>
                        {/* </Typography> */}
                      </div>
                    ))}
                  </div>
                ) : (
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      marginTop: "20px",
                      color: "#373b3e",
                    }}
                  >
                    No attendance data found without checkout for the selected
                    Data.
                  </Typography>
                )}
              </div>              
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            {/* <ReportsAnalytics/> */}
          </Grid2>
        </Grid2>
      </Box>
    </DashboardLayout>
  );
};

export default HRdashboard;
